import { useContext, useMemo } from 'react';
import { ThemeContext } from 'styled-components';

import { MenuConfig, ThemeConfig } from '#/service/config';

import Header from '../Header';
import { CenteredSpinner, SplashBg } from './styled';

interface SplashProps {
  /** The menu data */
  menu: MenuConfig;
  /** Theme. Only used in tests. Runtime it is coming from context. */
  theme?: ThemeConfig;
  /** Start fading out when this turns true. */
  startFadeout?: boolean;
}

/** Splash screen component */
function Splash({ menu, theme, startFadeout = false }: SplashProps) {
  const { color: { pageBackground = 'black' } = {} } =
    useContext(ThemeContext) || theme || {};

  // make a copy of the menu without the menu items
  const emptyMenu = useMemo(
    () => ({ ...menu, mainMenuItems: [], linkMenuItems: [] }),
    [menu]
  );

  if (!menu) {
    return null;
  }

  return (
    <SplashBg
      $backgroundColor={pageBackground}
      $startFadeout={startFadeout}
      data-testid="splash-background"
      key="splash-bg"
    >
      <Header cacheKey="splash-header" menu={emptyMenu} />
      <CenteredSpinner data-testid="splash-spinner" />
    </SplashBg>
  );
}

export default Splash;
